import React from 'react'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import styled from 'styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Banner from '../components/Banner'
import { graphql, Link } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { Helmet } from 'react-helmet'
import Comments from '../components/DisqusThread'

const PostTemplate = ({ data }) => {
  const {
    mdx: {
      frontmatter: { title, category, slug, image, date, embeddedImages },
      body,
      id,
    },
  } = data

  const APP_NAME = 'DevsrcBlog'

  return (
    <React.Fragment>
      <Helmet>
        <title>
          {title} | {APP_NAME}
        </title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        ></meta>
        <meta
          name="description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <link
          rel="canonical"
          href={`https://mdx-blog-testing-mode.netlify.app/posts/${slug}`}
        />
        <meta
          property="og:title"
          content={`Latest web developoment tutorials | ${APP_NAME}`}
        />
        <meta
          property="og:description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <meta property="og:type" content="webiste" />
        <meta
          property="og:url"
          content={`https://mdx-blog-testing-mode.netlify.app/posts/${slug}`}
        />
        <meta property="og:site_name" content={`${APP_NAME}`} />

        <meta
          property="og:image"
          content={`https://mdx-blog-testing-mode.netlify.app/posts/${slug}`}
        />
        <meta
          property="og:image:secure_url"
          content={`https://mdx-blog-testing-mode.netlify.app/posts/${slug}`}
        />
        <meta property="og:image:type" content="image/jpg" />
      </Helmet>

      <Layout>
        <Hero customTop />
        <Wrapper>
          {/* post info */}
          <article>
            <GatsbyImage
              image={getImage(image)}
              alt={title}
              className="main-img"
            />
            <div className="post-info">
              <span>
                <Link to={`/${category}`} style={{ color: 'white' }}>
                  {category}
                </Link>
              </span>
              <h1>{title}</h1>
              <p>{date}</p>
              <div className="underline"></div>
            </div>
            <MDXRenderer embeddedImages={embeddedImages}>{body}</MDXRenderer>
          </article>
          {/* banner component */}
          <article>
            <Banner />
          </article>
          <Comments
            id={id}
            title={title}
            path={`/blog/${slug}`}
            style={{ marginTop: '20px' }}
          />
        </Wrapper>
      </Layout>
    </React.Fragment>
  )
}

export const query = graphql`
  query GetSinglePost($slug: String) {
    mdx(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        title
        category
        date(formatString: "MMMM Do, YYYY")
        readTime
        slug
        embeddedImages {
          childImageSharp {
            gatsbyImageData
          }
        }
        image {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      body
      id
    }
  }
`

const Wrapper = styled.section`
  width: 85vw;
  max-width: 1100px;
  margin: 0 auto;
  margin-bottom: 4rem;

  .post-info {
    margin: 2rem 0 4rem 0;
    text-align: left;
    span {
      background: var(--clr-primary-5);
      color: var(--clr-white);
      border-radius: var(--radius);
      padding: 0.25rem 0.5rem;
      text-transform: uppercase;
      letter-spacing: var(--spacing);
    }
    h1 {
      margin: 1.25rem 0;
      font-weight: 400;
    }
    p {
      color: var(--clr-grey-5);
    }
    .underline {
      width: 5rem;
      height: 1px;
      background: var(--clr-grey-9);
      margin: 0 auto;
      margin-bottom: 1rem;
    }
  }
  @media (min-width: 992px) {
    & {
      width: 92vw;
    }
    .main-img {
      width: 75%;
      display: block;
      margin: 0 auto;
    }
  }
  @media (min-width: 1170px) {
    & {
      display: grid;
      grid-template-columns: 1fr 200px;
      column-gap: 4rem;
    }
  }
`

export default PostTemplate
